<ion-header>
  <ion-toolbar mode="md">
    <ion-title>Asistence: {{ assistance.client?.user?.firstName }} {{ assistance.client?.user?.lastName }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- FAB -->
  <!-- TODO LATER extract to separate component ideally-->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ng-container *ngIf="fab.states[RoleAssistantFabState.working]">
      <ion-button class="fab" color="secondary">
        <ion-spinner name="bubbles"></ion-spinner>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToBeConfirmed]">
      <ion-button class="fab" (click)="confirmAssistance()" color="secondary">
        <ion-icon name="checkmark"></ion-icon>
        <span>Potvrdit asistenci</span>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToStart]">
      <ion-button class="fab" (click)="startAssistance()" color="secondary">
        <ion-icon name="play"></ion-icon>
        <span>Začít asistenci</span>
      </ion-button>
    </ng-container>

    <ng-container *ngIf="fab.states[RoleAssistantFabState.assistanceReadyToEnd]">
      <ion-button class="fab" (click)="askEndAssistance()" color="secondary">
        <ion-icon name="stop"></ion-icon>
        <span>Ukončit asistenci</span>
      </ion-button>
    </ng-container>

  </ion-fab>

  <!-- FAB END -->

  <ion-list id="list" lines="full" class="accomodate-toolbar-above ion-no-margin ion-no-padding">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Plánovaný čas asistence</ion-label>
            <div slot="end" id="plannedDate">
              <app-date-range-view
                [startDate]="assistance.plannedFrom"
                [endDate]="assistance.plannedTo"
              ></app-date-range-view>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="assistance.realizedFrom">
        <ion-col size="12">
          <ion-item>
            <ion-label>Skutečný čas asistence</ion-label>
            <div slot="end" id="realizedDate">
              <app-date-range-view
                [startDate]="assistance.realizedFrom"
                [endDate]="assistance.realizedTo"
              ></app-date-range-view>
            </div>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item>
            <ion-label>Stav</ion-label>
            <span [style.backgroundColor]="assignment?.status?.color" class="status-colored">
              {{ assignment?.status?.humanReadableName }}
            </span>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-item class="ion-text-end">
            <ion-label>Popis</ion-label>
            {{ assistance.shortDescription }}
          </ion-item>

          <ion-item>
            <ion-label>Kontakt na klienta</ion-label>
            {{ assistance.client | getPrimaryContact }}
          </ion-item>

          <ion-item>
            <ion-label>Koordinátor klienta</ion-label>
            {{ (keyCoordinator$ | async)?.fullName() }}
          </ion-item>

          @if (FeatureFlags.roleAssistantAssistanceEditor_showJournalEntryEditorNotice) {
            <ion-item class="justify-self-center">
              <ion-chip (click)="scrollToTagEditor()" color="secondary">
                <ion-label>Zpětná vazba je nyní "Můj deníkový zápis"</ion-label>
                <ion-icon name="arrow-down-outline"></ion-icon>
              </ion-chip >
            </ion-item>
          }

          <ion-item-divider>
            <ion-label>Adresa</ion-label>
          </ion-item-divider>

          <ion-item>
            <ion-label>Začátek</ion-label>
            {{ assistance.addressStart }}
          </ion-item>
          <ion-item>
            <ion-label>Konec</ion-label>
            {{ assistance.addressEnd }}
          </ion-item>

          <ion-item-divider>
            <ion-label></ion-label>
          </ion-item-divider>

          <ion-accordion-group [multiple]="true">
            @if (canWriteJournalEntry) {
              <ion-accordion #tagEditorAnchor>
                <ion-item slot="header">
                  <ion-label>{{ 'ASSISTANCE_CARE_LOG_EDITOR.MY_JOURNAL_ENTRY' | transloco }}</ion-label>
                  <ion-button slot="end" (click)="saveJournalEntry()" [disabled]="savingJournalEntry || !isJournalEntryDirty">{{ 'ASSISTANCE_CARE_LOG_EDITOR.SAVE_ENTRY' | transloco }}</ion-button>
                </ion-item>
                <div slot="content">
                  <ion-item lines="none">
                    <app-tag-editor
                      class="ion-padding-top"
                      [ngModel]="myJournalEntry"
                      (ngModelChange)="onMyJournalEntryChange($event)"
                      [clientId]="assistance.clientId"
                      [placeholder]="'TAG_EDITOR.ENTER_NOTES_PLACEHOLDER' | transloco"
                    ></app-tag-editor>
                  </ion-item>
                </div>
              </ion-accordion>
            }

            <ion-accordion [disabled]="!assistance.realizedFrom">
              <ion-item slot="header">
                <ion-label>
                  {{ 'ASSISTANCE_CARE_LOG_EDITOR.TASKS' | transloco }}
                </ion-label>
                <ion-chip>{{ totalCareLogMinutes }} {{ 'ASSISTANCE_CARE_LOG_EDITOR.TOTAL_MINUTES' | transloco }}</ion-chip>
              </ion-item>
              <ion-item slot="content"
                        class="ion-padding-bottom"
              >
                @if (assistance.id) {
                  <app-assistance-care-log-editor
                    [assignments]="mappedAssistantAssignment"
                    [assistanceId]="assistance.id"
                    [clientId]="assistance.clientId"
                    [role]="'assistant'"
                    [readonly]="!assistance.realizedFrom"
                    [currentAssistantId]="assistantId"
                    [maxTotalMinutes]="assistanceElapsedMinutes"
                    [(ngModel)]="totalCareLogMinutes"
                  />
                }
              </ion-item>

            </ion-accordion>
          </ion-accordion-group>

          <ion-item-divider>
            <ion-label>Detailní popis výkonu</ion-label>
          </ion-item-divider>

          <ion-item>
            <div id="detailedDescription" [innerHTML]="(assistance.detailedDescription ?? '') | bypassHtmlSanitizer"></div>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-list>
</ion-content>
